module.exports = __webpack_public_path__ + "img/more-icon-01.ed376bd0.gif";